export default "__VITE_ASSET__Exn_zLIT__"